<div class="dialog">
  <div class="dialog__main">
    <div class="dialog__header">
      <div class="dialog__header-left">
        <h1 class="dialog__title">メモ取り込み結果確認</h1>
        <span class="dialog__header-text">求職者: {{
          student.dynamicData?.lastName + " " + student.dynamicData?.firstName
        }}</span>
      </div>
      <div class="dialog__header-right">
        <div class="dialog__header--checkbox-area">
          <input
            id="registerSituationMemoFlg"
            type="checkbox"
            name="registerSituationMemoFlg"
            [(ngModel)]="registerSituationMemoFlg"
          />
          <label class="dialog__header--checkbox-label" for="registerSituationMemoFlg">状況メモにも登録</label>
        </div>
        <div class="dialog__header--checkbox-area">
          <input
            id="register2ndMatchFlg"
            type="checkbox"
            name="register2ndMatchFlg"
            [(ngModel)]="register2ndMatchFlg"
          />
          <label class="dialog__header--checkbox-label" for="register2ndMatchFlg">セカマ条件に設定</label>
        </div>
        <button class="dialog__button dialog__button--accent" (click)="close()">
          反映画面に戻る
        </button>
        <button
          class="dialog__button dialog__button--primary"
          (click)="update()"
        >
          更新を実行
        </button>
      </div>
    </div>
    <div class="dialog__body">
      <ng-content
        *ngTemplateOutlet="
          counselingMemoStudentDiffForm;
          context: {
            student: student,
            currentUserId: currentUserId,
            uploadType: uploadType,
            parsedResult: {},
            dynamicFields: counselingMemoStudentDiffFormConfigFields
          }
        "
      ></ng-content>
    </div>
  </div>
  <!-- メモの変更点出力 -->
  <div class="dialog__sub">
    <div class="dialog__sub-header">
      <h1 class="dialog__sub-header-title">面談メモ（引用元）</h1>
      <span class="dialog__sub-header-text">ハイライト部分が抽出根拠です</span>
    </div>
    <div class="dialog__sub-body">
      <div
        class="dialog-content__memo-section"
      >
        <span
          *ngFor="let memoLine of memoRawChunked; let i = index"
          class="dialog-content__memo-line"
          [ngClass]="{
            'marked': memoToBeMarkedLines.includes(i)
          }"
        >
          {{ memoLine }}
        </span>
      </div>
    </div>
  </div>
</div>


<ng-template
  #counselingMemoStudentDiffForm
  let-student="student"
  let-currentUserId="currentUserId"
  let-uploadType="uploadType"
  let-parsedResult="parsedResult"
  let-dynamicFields="dynamicFields"
>
  <div class="dialog-content__section">
    <!-- <span class="dialog-content__section-text">「カウンセリング内容」を記入してください</span> -->

    <div
      class="dialog-content__info"
      *ngIf="uploadType === UploadType.REGISTER"
    >
      <div
        class="dialog-content__info--row"
      >
        初回固定項目更新
      </div>
      <div
        class="dialog-content__info--row"
      >
        <div
          class="dialog-content__info--row-item"
          *ngIf="!editingRegisterInfo"
        >
          <span class="bolder-text">登録ステータス</span>
          <span>更新: <span class="bolder-text">{{registerInfo.registrationStatus}}</span></span>
        </div>
        <div
          class="dialog-content__info--row-item"
          *ngIf="!editingRegisterInfo"
        >
          <span class="bolder-text">面談ステータス</span>
          <span>更新: <span class="bolder-text">{{registerInfo.interviewStatus}}</span></span>
        </div>
        <div
          class="dialog-content__info--row-item"
          *ngIf="!editingRegisterInfo"
        >
          <span class="bolder-text">担当者</span>
          <ng-container
            *ngIf="
              userTeamInjector.getUserTeamInfoById(registerInfo.userId) | async as user
            "
          >
            <span>更新: <span class="bolder-text">{{user.name}}</span></span>
          </ng-container>
        </div>
        <div
          class="dialog-content__info--row-item"
          *ngIf="!editingRegisterInfo"
        >
          <span class="bolder-text">カウンセリング日</span>
          <span>更新: <span class="bolder-text">{{interviewDateForDisplay()}}</span></span>
        </div>

        <ag-dynamic-form
          *ngIf="editingRegisterInfo"
          [metadata]="metadataRegister"
          [model]="registerInfo"
          (changed)="onModelChange($event)"
        ></ag-dynamic-form>

        <div
          class="dialog-content__info--row-item no-border"
        >
          <button class="dialog-content__info--row-item-edit-button" type="button" *ngIf="!editingRegisterInfo" (click)="toggleEditingRegisterInfo()"> 編集 </button>
          <button class="dialog-content__info--row-item-edit-button" type="button" *ngIf="editingRegisterInfo"  (click)="toggleEditingRegisterInfo()"> 編集を閉じる </button>
        </div>
      </div>
    </div>
    <div
      class="dialog-content__field"
      *ngFor="let dynamicField of dynamicFields"
    >
      <div class="dialog-content__field-head">
        <span class="dialog-content__field-head-row">
          {{ getStudentDynamicFieldCategory(dynamicField.fieldName) }}
        </span>
        <span class="dialog-content__field-head-row bolder-text">
          {{ dynamicField.label }}
        </span>
        <div
          class="dialog-content__field-head-row"
          *ngIf="existDiffBetweenStudentDynamicFieldAndMemoParsed(dynamicField)"
        >
          <span class="btn btn-small diff-label">差分あり</span>
        </div>
        <div
          class="dialog-content__field-head-row"
          *ngIf="!existDiffBetweenStudentDynamicFieldAndMemoParsed(dynamicField)"
        >
          <span class="btn btn-small nodiff-label">差分なし</span>
        </div>
        <div
          class="dialog-content__field-head-row"
          *ngIf="
            isEmptyMemoData(memoParsed[dynamicField.fieldName], dynamicField) &&
            !isEmptyMemoData(student.dynamicData[dynamicField.fieldName], dynamicField)
          "
        >
          <input
            [id]="'updateWithNull-' + dynamicField.fieldName"
            class="update_with_null_input"
            type="checkbox"
            [name]="'updateWithNull-' + dynamicField.fieldName"
            [(ngModel)]="updateWithNullFieldList[dynamicField.fieldName]"
          />
          <label [for]="'updateWithNull-' + dynamicField.fieldName">空で更新</label>
        </div>
      </div>
      <div class="dialog-content__field-body">
        <div class="dialog-content__field-body-row">
          <div class="dialog-content__field-body--to-be-updated-value">
          <span class="dialog-content__field--sub-text">
            <span class="dialog-content__field--sub-text-foot"></span>
          </span>
          <ag-counseling-memo-dynamic-field-input
            [fieldDefinition]="dynamicField"
            [value]="memoParsed[dynamicField.fieldName]"
            (onChanged)="onParsedMemoDataChanged($event, dynamicField)"
          ></ag-counseling-memo-dynamic-field-input>
          </div>
          <div class="dialog-content__field-body--current-value">
            <span class="dialog-content__field--sub-text">
              <span class="dialog-content__field--sub-text-foot">
                現在値（Mach）
              </span>
            </span>
            <ag-counseling-memo-dynamic-field-input
              [fieldDefinition]="dynamicField"
              [value]="student.dynamicData[dynamicField.fieldName]"
              [readonly]="true"
            ></ag-counseling-memo-dynamic-field-input>
          </div>
        </div>
        <div
          class="dialog-content__field-body-row"
          *ngIf="memoParsedLineDiff &&
            memoParsedLineDiff[dynamicField.fieldName] &&
            memoParsedLineDiff[dynamicField.fieldName].length > 0
          "
        >
          <span class="dialog-content__field--sub-text">
            <span
              class="dialog-content__field--sub-text-foot"
              *ngFor="let memoLine of memoParsedLineDiff[dynamicField.fieldName]; let i = index">
              <span *ngIf="i === 0">根抛：</span>{{ memoLine }}
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
